import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import * as bie from "react-bootstrap";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import {
  ERROR_MSG,
  MOBILE_VALIDATION,
} from "../../CommonUtils/contextVariables";
import {
  failureAlert,
  successAlert2,
  successAlertRefresh,
} from "../../CommonUtils/SweetAlerts";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import allowNumbersOnly, {
  allowAlphabetAndSpacesOnly,
  handlePaste,
} from "../../CommonUtils/CommonValidations";

export default function UniversityAssigningInsp() {


  const userid = sessionStorage.getItem("user_id");

  const [SubmittedRes, setSubmittedRes] = useState();
  const [showmsg, setmsg] = useState(false);
  const [clgcmpltedsstatus, setclgcmpltedsstatus] = useState([]);

  const hasFetchedData = useRef(false);

  const validationSchema = Yup.object().shape({
    officerName: Yup.string().required(ERROR_MSG), // Team Head Name
    Designation: Yup.string().required(ERROR_MSG), // Designation
    mobileNo: Yup.string()
      .required(ERROR_MSG)
      .matches(MOBILE_VALIDATION, "Invalid mobile number"), // Contact No
    // univAssocYears: Yup.number()
    //     .typeError("Must be a number")
    //     .required(ERROR_MSG), // No of years of association
    dateOfInspec: Yup.string().required(ERROR_MSG), // Date of inspection
    // deptCode: Yup.string()
    //     .required(ERROR_MSG), // Department code
    // verificationType: Yup.string()
    //     .required(ERROR_MSG), // Physical or Virtual verification
    // verificationType: Yup.string().when("$userid", {
    //   is: (userid) => userid !== "degree_admin",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    verificationType: Yup.string().when([], {
      is: () => userid !== "jd_admin", // external variable
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    officerWorkingAtOther: Yup.string().when(
      "presentlyWrkng",
      (presentlyWrkng, schema) => {
        if (presentlyWrkng === "9999") {
          return schema.required("This field is required");
        }
        return schema.notRequired();
      },
    ),
    // presentlyWrkng: Yup.string()
    //     .required(ERROR_MSG), // Presently working at
    aadhar: Yup.string()
      .matches(/^\d{12}$/, "Aadhaar must be 12 digits")
      .notRequired(), // Optional Aadhaar
    // univIssuedIdNo: Yup.string()
    //     .max(10, "Maximum 10 characters")
    //     .notRequired(), // Optional University ID
    cfmsIdNo: Yup.string().max(10, "Maximum 10 characters").notRequired(), // Optional CFMS ID
    // Optional numeric field: number of inspections being attended same date
    inspecDateColleges: Yup.number()
      .typeError("Must be a number")
      .notRequired(),
  });
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const handleView = (student) => {
    setShowModal(true);
  };

  const UnivwiseafflDtls = useFormik({
    initialValues: {
      officerName: "",
      gmail: "",
      Designation: "",
      officerDesignation: "",
      // presentlyWrkng: "",
      mobileNo: "",
      // univIssuedIdNo: "",
      cfmsIdNo: "",
      // univAssocYears: "",
      dateOfInspec: "",
      inspecDateColleges: "",
      // deptCode: "",
      aadhar: "",
      verificationType: "",
      tableData: [],
      officerWorkingAtOther: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFinalSubmit(values, collcode);
    },
  });

  const handleFinalSubmit = (values, collCode) => {
    // Base payload
    let updatedValues = {
      ...values,
      mobileNo: parseInt(values.mobileNo || ""),
      inspecDateColleges: parseInt(values.inspecDateColleges || ""),
      aadhar: parseInt(values.aadhar || ""),
      collCode: collCode,
    };

    // ✅ If degree_admin, assign row-wise verification_type to verificationType
    if (userid === "jd_admin" && Array.isArray(values.tableData)) {
      const rowIndex = values.tableData.findIndex(
        (row) => row.coll_code === collCode,
      );

      if (rowIndex !== -1) {
        updatedValues.verificationType =
          values.tableData[rowIndex].verification_type || "";
      }
    }
    Swal.fire({
      text: "Are you sure you want to submit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const url = `${config.url.FAC_URL}saveInspectionAllotement`;
        CommonAxiosPost(url, updatedValues).then((res) => {
          if (res?.data?.scode === "01") {
            successAlertRefresh(res?.data?.sdesc);
          } else {
            failureAlert(res?.data?.sdesc);
          }
        });
      } else {
        console.log("Submission canceled");
      }
    });
  };

  function GetInspData() {
    let url = config?.url?.FAC_URL + "getAlloteInsp";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        const allotData = res?.data?.allot || [];
        setclgcmpltedsstatus(allotData);
        // ✅ Map data before setting
        const formattedTableData = allotData.map((row) => ({
          user_id: row.user_id || "",
          coll_code: row.coll_code || "",
          verification_type: row.verification_type || "",
          inst_type: row.inst_type || "",
          inst_name: row.inst_name || "",
          affl_insp_status: row.affl_insp_status || "",
          mobile_email: row.mobile_email || "",
          noc_type: row.noc_type || "",
        }));
        UnivwiseafflDtls.setFieldValue("tableData", formattedTableData);
      } else {
        setclgcmpltedsstatus([]);
        UnivwiseafflDtls.setFieldValue("tableData", []);
      }
    });
  }

  function GetSelectedprincpleData(CFMSID) {
    let url = config?.url?.FAC_URL + "principacfmsldata/" + CFMSID;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.status === true) {
        res?.data?.principalcfmsdata?.forEach((univData, i) => {
          // const DateofInsp = univData?.date_of_inspec && moment(univData?.date_of_inspec,
          //     'DD/MM/YYYY', true).isValid() ? moment(univData?.date_of_inspec, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
          UnivwiseafflDtls?.setFieldValue("mobileNo", univData?.mobile);
          UnivwiseafflDtls?.setFieldValue("gmail", univData?.emai_id);
          UnivwiseafflDtls?.setFieldValue(
            "Designation",
            univData?.principal_type,
          );
          UnivwiseafflDtls?.setFieldValue("cfmsIdNo", univData?.cfms_id);
        });
      } else {
        console.log("Data not Found");
      }
    });
  }
  const [principledata, setPrincipledata] = useState([]);
  function GetPrincipleData() {
    let url = config?.url?.FAC_URL + "principaldata";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setPrincipledata(res?.data?.principaldata);
      } else {
        setPrincipledata([]);
      }
    });
  }

  useEffect(() => {
    if (!hasFetchedData.current) {
      GetInspData();
      GetPrincipleData();
      // GetDesignations();
      // GetDepartments();
      // GetSubjectList();
      hasFetchedData.current = true;
    }
  }, []);

  const [InstName, setInstName] = useState([]);
  const [collcode, setcollcode] = useState("");
  const [userId, setuserId] = useState([]);

  const Columns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>
      ),
    },

    {
      id: "mobile_email",
      header: "Contact Details",
      accessorKey: "mobile_email",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>{row.original.mobile_email}</div>
      ),
    },


    {
      id: "user_id",
      header: "Inspection User Id",
      accessorKey: "user_id",
      meta: { style: { textAlign: "center" } },
    },

    ...(userid === "jd_admin"
      ? [
        {
          id: "noc_type",
          header: "NOC Type",
          accessorKey: "noc_type",
          meta: { style: { textAlign: "center" } },
        },
        {
          id: "verificationType",
          header: "Verification Type",
          cell: ({ row }) => {
            const index = row.index;

            return (
              <div style={{ minWidth: "200px" }}>
                <Field
                  as="select"
                  name={`tableData[${index}].verification_type`} // <- bind to row
                  className="form-control"
                >
                  <option value="">---select---</option>
                  <option value="physical_committee">
                    Physical Committee
                  </option>
                  <option value="virtual_committee">Virtual Committee</option>
                  <option value="online_scrutiny">Online Scrutiny</option>
                </Field>

                <ErrorMessage
                  name={`tableData[${index}].verification_type`} // <- show row errors
                  component="div"
                  className="text-danger"
                />
              </div>
            );
          },
        },
      ]
      : []),
    {
      id: "actions",
      header: "Mapping for Reset Password",
      cell: ({ row, table }) => {
        const status = row.original.affl_insp_status;

        return (
          <div>
            {status === "Mapping or Reset Password" ? (
              <button
                type="button"
                className="btn btn-success btn-sm float-end rounded mb-2"
                onClick={() => {
                  if (userid === "jd_admin") {
                    // ✅ Get the row-specific verification_type
                    const rowVerificationType =
                      UnivwiseafflDtls?.values?.tableData[row.index]
                        ?.verification_type;

                    // Check empty
                    if (!rowVerificationType) {
                      Swal.fire({
                        icon: "warning",
                        title: "Please select Verification Type",
                      });
                      return;
                    }

                    // If "online_scrutiny" → call submit
                    if (rowVerificationType === "online_scrutiny") {
                      handleFinalSubmit(
                        UnivwiseafflDtls?.values,
                        row.original.coll_code,
                      );
                      return; // stop further execution
                    }
                  }

                  // Normal flow
                  GetPrincipleData();
                  handleView();
                  setmsg(false);
                  setInstName(row.original.inst_name);
                  setcollcode(row.original.coll_code);
                }}
              >
                Mapping or Reset Password
              </button>
            ) : status === "completed" ? (
              <span
                className="float-end px-3 py-2 rounded"
                style={{
                  backgroundColor: "#e7f1ff",
                  color: "#0d6efd",
                  fontWeight: "500",
                  fontSize: "13px",
                }}
              >
                ✔ Already Assigned Inspection
              </span>
            ) : null}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={UnivwiseafflDtls}>
          <Form
            onChange={UnivwiseafflDtls.handleChange}
            onSubmit={UnivwiseafflDtls.handleSubmit}
            className="affl-form"
          >
            <bie.Row className="px-2 pt-3 mb-3 w-100">
              <h5 className="mb-3 innerheader-new">
                <span>Allot Team Member Report</span>
              </h5>
              {clgcmpltedsstatus?.length > 0 ? (
                <>
                  <div className="table-responsive">
                    <CommonReactTable
                      data={clgcmpltedsstatus}
                      columns={Columns}
                      filename="AsiignInspectionToByUniversity"
                      headerName={`Allot Team Member Report`}
                      showFooter={false}
                      showPagination={false}
                      showExcel={true}
                      showPrint={false}
                      excelFileName="University Assign Inspection"
                    />
                  </div>
                </>
              ) : (
                <center className="text-danger h6">
                  *** No Data Found ***
                </center>
              )}
              <bie.Modal show={showModal} onHide={handleClose} size="xl">
                <bie.Modal.Header
                  closeButton
                  style={{ backgroundColor: "#bbc2e9" }}
                >
                  <bie.Modal.Title>
                    Assigning Inspection Team to {InstName} College
                  </bie.Modal.Title>
                </bie.Modal.Header>

                <bie.Modal.Body>
                  <FormikProvider value={UnivwiseafflDtls}>
                    <Form
                      onSubmit={UnivwiseafflDtls?.handleSubmit}
                      onChange={UnivwiseafflDtls?.handleChange}
                      className="affl-form"
                    >
                      <>
                        {showmsg === true ? (
                          <>
                            <bie.Alert variant="danger">
                              <p className="mb-0">
                                Password Reset Successful. User Details of FFCA-
                                <strong>{InstName}</strong> sent to FFCA
                                Convenor -
                                <span className="highlight">
                                  {UnivwiseafflDtls?.values?.officerName}
                                </span>
                                <br />
                                <p className="cen mb-0">
                                  User-ID:
                                  <span className="highlight user-id">
                                    {userId}
                                  </span>
                                  Password:
                                  <span className="highlight password">
                                    {SubmittedRes?.smsId}
                                  </span>
                                  SMS Sent.
                                </p>
                              </p>
                            </bie.Alert>
                          </>
                        ) : (
                          <>
                            {/* <bie.Alert variant='danger'>
                                                        <p className='mb-0'>
                                                            <strong>Note:</strong> Please enter one FFCA Team Head details so that this Password will be sent to their Mobile.
                                                            <br />
                                                            Aadhaar and university ID details are not mandatory.
                                                        </p>
                                                    </bie.Alert> */}
                          </>
                        )}

                        {/* {showmsg === false ? (<> */}

                        <bie.Row>
                          {/* <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">Team Head Name</b> </label>
                                                            <Field type='text' name="officerName" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                                                                className="form-control mb-2" maxLength={70}></Field>
                                                            <ErrorMessage name="officerName" component="div" className="text-danger" />
                                                        </bie.Col> */}
                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="field-mandatory">
                                Team Head Name
                              </b>{" "}
                            </label>
                            <Field
                              as="select"
                              name="officerName"
                              onChange={(e) => {
                                GetSelectedprincpleData(e?.target?.value);
                              }}
                              className="form-control mb-2"
                            >
                              <option value="">--SELECT--</option>

                              {principledata &&
                                principledata?.map((rel, i) => (
                                  <option value={rel?.cfms_id}>
                                    {rel?.principal_name}
                                  </option>
                                ))}
                            </Field>
                            <ErrorMessage
                              name="officerName"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>
                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="field-mandatory">
                                Designation
                              </b>{" "}
                            </label>
                            <Field
                              type="text"
                              name="Designation"
                              onKeyPress={(e) => {
                                allowAlphabetAndSpacesOnly(e);
                              }}
                              className="form-control mb-2"
                              maxLength={50}
                            ></Field>
                            <ErrorMessage
                              name="Designation"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>

                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="field-mandatory">G-mail</b>{" "}
                            </label>
                            <Field
                              type="email"
                              name="gmail"
                              className="form-control mb-2"
                              maxLength={70}
                            ></Field>
                            <ErrorMessage
                              name="gmail"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>
                          {/* <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">Department</b> </label>
                                                            <Field as="select" name="deptCode" className="form-control mb-2">

                                                                <option value=''>--SELECT--</option>

                                                                {DeptList && DeptList.map((rel, i) => (
                                                                    <option value={rel?.board_discipline_group_id}>{rel?.board_discipline_group}</option>
                                                                ))}
                                                            </Field>
                                                            <ErrorMessage name="deptCode" component="div" className="text-danger" />
                                                        </bie.Col> */}

                          {/* <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                            <label className='mb-1'> <b className="field-mandatory">Presently Working at</b> </label>
                                                            <Field as="select" name="presentlyWrkng" className="form-control mb-2" onChange={(e) => {
                                                                UnivwiseafflDtls?.setFieldValue("officerWorkingAtOther", "")
                                                            }}  >
                                                                <option value=''>--SELECT--</option>

                                                                {Sublist && Sublist?.map((rel, i) => (
                                                                    <option value={rel?.ub_code}>{rel?.ub_name}</option>
                                                                ))}
                                                                <option value="9999">Other University</option>

                                                            </Field>
                                                            <ErrorMessage name="presentlyWrkng" component="div" className="text-danger" />
                                                        </bie.Col> */}
                          {UnivwiseafflDtls?.values?.presentlyWrkng ===
                            "9999" ? (
                            <>
                              <bie.Col
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                                xxl={4}
                              >
                                {/* <bie.InputGroup className="mb-4p5"> */}
                                <label className="mb-1">
                                  {" "}
                                  <b className="field-mandatory">
                                    Other University name
                                  </b>{" "}
                                </label>
                                <Field
                                  type="text"
                                  name="officerWorkingAtOther"
                                  className="form-control mb-2"
                                />
                                <ErrorMessage
                                  name="officerWorkingAtOther"
                                  component="div"
                                  className="text-danger"
                                />
                                {/*</bie.InputGroup> */}
                              </bie.Col>
                            </>
                          ) : (
                            <></>
                          )}

                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            {/* <bie.InputGroup className="mb-4p5"> */}
                            <label className="mb-1">
                              {" "}
                              <b className="">Aadhaar</b>{" "}
                            </label>
                            <Field
                              type="text"
                              name="aadhar"
                              className="form-control mb-2"
                              onKeyPress={(e) => {
                                allowNumbersOnly(e);
                              }}
                              onPaste={(e) => handlePaste(e)}
                              maxLength={12}
                            ></Field>

                            <ErrorMessage
                              name="aadhar"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>
                          {/* < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                        <label className='mb-1'> <b className="">University issued id No</b> </label>
                                                        <Field type="text" name="univIssuedIdNo" className="form-control mb-2" maxLength="10"></Field>

                                                        <ErrorMessage name="univIssuedIdNo" component="div" className="text-danger" />

                                                    </bie.Col> */}
                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="">CFMS id/Emp id</b>{" "}
                            </label>
                            <Field
                              type="text"
                              name="cfmsIdNo"
                              className="form-control mb-2 mt-3"
                              maxLength="10"
                              onKeyPress={(e) => {
                                allowNumbersOnly(e);
                              }}
                              onPaste={(e) => handlePaste(e)}
                            ></Field>

                            <ErrorMessage
                              name="cfmsIdNo"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>

                          {/* < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                        <label className='mb-1'> <b className="field-mandatory">No of years of association with the university</b> </label>
                                                        <Field type="text" name="univAssocYears" className="form-control mb-2" maxLength="2" onKeyPress={(e) => {
                                                            allowNumbersOnly(e)
                                                        }} onPaste={(e) => handlePaste(e)}></Field>
                                                        <ErrorMessage name="univAssocYears" component="div" className="text-danger" />
                                                    </bie.Col> */}
                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="field-mandatory">
                                College Assigned{" "}
                              </b>{" "}
                            </label>
                            <Field
                              type="text"
                              name="itemRateUpperLimit"
                              className="form-control mb-2 mt-3"
                              disabled
                              value={InstName}
                            />
                            <ErrorMessage
                              name="itemRateUpperLimit"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>
                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="field-mandatory">
                                Date of inspection
                              </b>{" "}
                            </label>
                            <Field
                              type="date"
                              name="dateOfInspec"
                              className="form-control mb-2 mt-4"
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                              min={new Date().toISOString().split("T")[0]}
                            ></Field>
                            <ErrorMessage
                              name="dateOfInspec"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>
                          {/* < bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='pt-2'>
                                                            <label className='mb-1'> <b className="field-mandatory">No of inspection being attended of the same  date</b> </label>
                                                            <Field type="text" name="inspecDateColleges" className="form-control mb-2" maxLength="5" onKeyPress={(e) => {
                                                                allowNumbersOnly(e)
                                                            }} onPaste={(e) => handlePaste(e)} />
                                                            <ErrorMessage name="inspecDateColleges" component="div" className="text-danger" />
                                                        </bie.Col> */}
                          <bie.Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={4}
                            xl={4}
                            xxl={4}
                          >
                            <label className="mb-1">
                              {" "}
                              <b className="field-mandatory">Contact No</b>{" "}
                            </label>
                            <Field
                              type="text"
                              name="mobileNo"
                              className="form-control mt-4 "
                              onKeyPress={(e) => {
                                allowNumbersOnly(e);
                              }}
                              onPaste={(e) => handlePaste(e)}
                              maxLength={10}
                            ></Field>
                            <ErrorMessage
                              name="mobileNo"
                              component="div"
                              className="text-danger"
                            />
                          </bie.Col>

                          {userid !== "jd_admin" && (
                            <bie.Col
                              xs={12}
                              sm={12}
                              md={12}
                              lg={4}
                              xl={4}
                              xxl={4}
                            >
                              <label className="mb-1">
                                {" "}
                                <b className="field-mandatory">
                                  Whether conducting physical (or) virtual
                                  verification
                                </b>{" "}
                              </label>
                              <Field
                                as="select"
                                name="verificationType"
                                className="form-control mb-2"
                              >
                                <option value="">---select---</option>
                                <option value="Physical_Verification">
                                  {" "}
                                  Physical Verification{" "}
                                </option>
                                <option value="Virtual_Verification">
                                  {" "}
                                  Virtual Verification
                                </option>
                              </Field>
                              <ErrorMessage
                                name="verificationType"
                                component="div"
                                className="text-danger"
                              />
                            </bie.Col>
                          )}
                        </bie.Row>
                        {/* </>) : (<></>)} */}

                        <bie.Row>
                          {/* <div className='d-flex flex-row justify-content-end pt-3'> */}

                          <div className="mt-4 d-flex justify-content-end">
                            <bie.Button
                              type="submit"
                              variant="success"
                              className="px-4 shadow-sm fw-bold"
                            >
                              Save Data
                            </bie.Button>
                          </div>

                          {/* </div> */}
                        </bie.Row>
                      </>
                    </Form>
                  </FormikProvider>
                </bie.Modal.Body>
              </bie.Modal>
            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container>
    </>
  );
}
